import NoteStore from '../stores/NoteStore.js';

const images = require.context('../../public/images', true);

function ScaleImage(props) {
  const noteNr = NoteStore.getNoteNr();
  const note = NoteStore.getNoteInfo(noteNr);
  const scaleNr = NoteStore.getScaleNr();
  const scale = NoteStore.getScaleInfo(scaleNr);

  const key = 'treble'; // treble or bass
  const sharps = scale.sharps || []; // [1, 4, 0, 3, 6, 2, 5]; // positions of the sharp signs in the scale
  const flats = scale.flats || [];

  // The note position is 0 for F on the bottom line. It ranges from -5 for the
  // lowest G to 13 for the highest D
  const notePosition = note.line;

  let lines = ''; // '', plus-1, plus-2, minus-1, minus-2
  if (notePosition <= -4) {
    lines = 'minus-2';
  } else if (notePosition <= -2) {
    lines = 'minus-1';
  } else if (notePosition >= 12) {
    lines = 'plus-2';
  } else if (notePosition >= 10) {
    lines = 'plus-1';
  }

  // lines name 'lines' with suffix
  let linesName = 'lines';
  if (lines !== '') {
    linesName += `-${lines}`;
  }

  const backgroundImage = images('./background.png');
  const keyImage = images(`./${key}-clef.png`);
  const linesImage = images(`./${linesName}.png`);
  const sharpImage = images('./sharp.png');
  const flatImage = images('./flat.png');
  const noteImage = images('./whole-note.png');

  const list = [];
  let xOffset = 0;
  sharps.forEach((nr) => {
    const yOffset = 4.4 * (nr-1);
    list.push(
      (
        <img src={sharpImage} alt='' key={nr} style={{
          position: 'absolute',
          left: '' + xOffset + '%',
          top: '' + yOffset + '%'
        }} />
      )
    );
    xOffset += 6;
  });

  xOffset = 0;
  flats.forEach((nr) => {
    const yOffset = 4.4 * (nr-3);
    list.push(
      (
        <img src={flatImage} alt='' key={nr} style={{
          position: 'absolute',
          left: '' + xOffset + '%',
          top: '' + yOffset + '%'
        }} />
      )
    );
    xOffset += 6;
  });

  const noteXOffset = 25;
  const noteYOffset = 4.4 * (-5.2 - notePosition) + 0.2;

  return (
    <div className="middle-image" style={{position: 'relative', zIndex: 0}}>
      <img src={backgroundImage} alt='' style={{position: 'relative'}} />
      <img src={linesImage} alt='' style={{position: 'absolute', top: 0}} />
      <img src={keyImage} alt=''  style={{position: 'absolute', top: 0}} />
      {list}
      <img src={noteImage} alt='' style={{
        position: 'absolute',
        top: '' + noteYOffset + '%',
        left: '' + noteXOffset + '%'
      }} />
    </div>
  );
}

export default ScaleImage;
